
export const recadastramentoRouter = [{
  path: "/" + process.env.VUE_APP_BASE_URL + "/formularios",
  component: () => import("@/paginas/recadastramento/recadastramento.vue"),
  children: [
    {
      path: "dados-pessoais",
      name: "RECAD_DADOS_PESSOAIS_VIEW",
      component: () => import("@/paginas/recadastramento/dadospessoais.vue"),
      meta: {
        auth: ["RECAD_DADOS_PESSOAIS_VIEW"]
      }
    },
    {
      path: "documentos",
      name: "RECAD_DOCUMENTOS_PESSOAIS_VIEW",
      component: () => import("@/paginas/recadastramento/documentosPessoais.vue"),
      meta: {
        auth: ["RECAD_DOCUMENTOS_PESSOAIS_VIEW"]
      }
    },
    {
      path: "endereco",
      name: "RECAD_ENDERECO_VIEW",
      component: () => import("@/paginas/recadastramento/endereco.vue"),
      meta: {
        auth: ["RECAD_ENDERECO_VIEW"]
      }
    },
    {
      path: "formacao-academica",
      name: "RECAD_FORMACAO_ACADEMICA_VIEW",
      component: () => import("@/paginas/recadastramento/formacaoAcademica.vue"),
      meta: {
        auth: ["RECAD_FORMACAO_ACADEMICA_VIEW"]
      }
    },
    {
      path: "dependentes",
      name: "RECAD_DEPENDENTES_VIEW",
      component: () => import("@/paginas/recadastramento/dependentes.vue"),
      meta: {
        auth: ["RECAD_DEPENDENTES_VIEW"]
      }
    },
    {
      path: "capacitacao",
      name: "RECAD_CAPACITACAO_VIEW",
      component: () => import("@/paginas/recadastramento/capacitacao.vue"),
      meta: {
        auth: ["RECAD_CAPACITACAO_VIEW"]
      }
    },
    {
      path: "experiencia-profissional",
      name: "RECAD_EXPERIENCIA_PROFISSIONAL_VIEW",
      component: () => import("@/paginas/recadastramento/experiencia-profissional.vue"),
      meta: {
        auth: ["RECAD_EXPERIENCIA_PROFISSIONAL_VIEW"]
      }
    },
    // {
    //   path: "questionario",
    //   name: "RECAD_QUESTIONARIO_VIEW",
    //   component: () =>
    //     import("@/paginas/recadastramento/questionarioBemEstar.vue"),
    // }"RECAD_QUESTIONARIO_VIEW",
    {
      path: "vinculos",
      name: "RECAD_VINCULOS_VIEW",
      component: () => import("@/paginas/recadastramento/vinculos.vue"),
      meta: {
        auth: ["RECAD_VINCULOS_VIEW"]
      }
    },
  ],
}]
